import { NgModule } from '@angular/core';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutModule } from 'app/layout/layouts/empty/empty.module';
import { ClassicLayoutModule } from 'app/layout/layouts/vertical/classic/classic.module';
import { SharedModule } from 'app/shared/shared.module';
import {DenseLayoutComponent} from "./layouts/vertical/dense/dense.component";
import {DenseLayoutModule} from "./layouts/vertical/dense/dense.module.";

const layoutModules = [
    // Empty
    EmptyLayoutModule,

    // Vertical navigation
    ClassicLayoutModule,

    DenseLayoutModule
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports: [
        SharedModule,
        ...layoutModules,
    ],
    exports     : [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule
{
}
